/**
 * @file HeaderSection.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Header component of courses.
 */
import { Breadcrumbs, Skeleton, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export const HeaderSection = ({ isLoading }) => {
  return (
    <>
      {isLoading ? (
        <Skeleton variant="rounded" width={180} height={24} />
      ) : (
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/master-settings">Master Settings</Link>
          <Typography sx={{ color: "text.primary" }}>Courses</Typography>
        </Breadcrumbs>
      )}
    </>
  );
};
